export default {
    "AF": {
        "name": "Afganistan"
    },
    "AL": {
        "name": "Albánsko"
    },
    "DZ": {
        "name": "Alžírsko"
    },
    "AD": {
        "name": "Andorra"
    },
    "AO": {
        "name": "Angola"
    },
    "AG": {
        "name": "Antigua a Barbuda"
    },
    "AR": {
        "name": "Argentína"
    },
    "AM": {
        "name": "Arménsko"
    },
    "AU": {
        "name": "Austrália"
    },
    "AZ": {
        "name": "Azerbajdžan"
    },
    "BS": {
        "name": "Bahamy"
    },
    "BH": {
        "name": "Bahrajn"
    },
    "BD": {
        "name": "Bangladéš"
    },
    "BB": {
        "name": "Barbados"
    },
    "BE": {
        "name": "Belgicko"
    },
    "BZ": {
        "name": "Belize"
    },
    "BJ": {
        "name": "Benin"
    },
    "BT": {
        "name": "Bhután"
    },
    "BY": {
        "name": "Bielorusko"
    },
    "BO": {
        "name": "Bolívia"
    },
    "BA": {
        "name": "Bosna a Hercegovina"
    },
    "BW": {
        "name": "Botswana"
    },
    "BR": {
        "name": "Brazília"
    },
    "BN": {
        "name": "Brunej"
    },
    "BG": {
        "name": "Bulharsko"
    },
    "BF": {
        "name": "Burkina"
    },
    "BI": {
        "name": "Burundi"
    },
    "CY": {
        "name": "Cyprus"
    },
    "TD": {
        "name": "Čad"
    },
    "CZ": {
        "name": "Česko"
    },
    "ME": {
        "name": "Čierna Hora"
    },
    "CL": {
        "name": "Čile"
    },
    "CN": {
        "name": "Čína"
    },
    "DK": {
        "name": "Dánsko"
    },
    "DM": {
        "name": "Dominika"
    },
    "DO": {
        "name": "Dominikánska republika"
    },
    "DJ": {
        "name": "Džibutsko"
    },
    "EG": {
        "name": "Egypt"
    },
    "EC": {
        "name": "Ekvádor"
    },
    "ER": {
        "name": "Eritrea"
    },
    "EE": {
        "name": "Estónsko"
    },
    "ET": {
        "name": "Etiópia"
    },
    "FJ": {
        "name": "Fidži"
    },
    "PH": {
        "name": "Filipíny"
    },
    "FI": {
        "name": "Fínsko"
    },
    "FR": {
        "name": "Francúzsko"
    },
    "GA": {
        "name": "Gabon"
    },
    "GM": {
        "name": "Gambia"
    },
    "GH": {
        "name": "Ghana"
    },
    "GR": {
        "name": "Grécko"
    },
    "GD": {
        "name": "Grenada"
    },
    "GE": {
        "name": "Gruzínsko"
    },
    "GT": {
        "name": "Guatemala"
    },
    "GN": {
        "name": "Guinea"
    },
    "GW": {
        "name": "Guinea-Bissau"
    },
    "GY": {
        "name": "Guyana"
    },
    "HT": {
        "name": "Haiti"
    },
    "NL": {
        "name": "Holandsko"
    },
    "HN": {
        "name": "Honduras"
    },
    "HR": {
        "name": "Chorvátsko"
    },
    "IN": {
        "name": "India"
    },
    "ID": {
        "name": "Indonézia"
    },
    "IR": {
        "name": "Irán"
    },
    "IQ": {
        "name": "Irak"
    },
    "IE": {
        "name": "Írsko"
    },
    "IS": {
        "name": "Island"
    },
    "IL": {
        "name": "Izrael"
    },
    "JM": {
        "name": "Jamajka"
    },
    "JP": {
        "name": "Japonsko"
    },
    "YE": {
        "name": "Jemen"
    },
    "JO": {
        "name": "Jordánsko"
    },
    "ZA": {
        "name": "Južná Afrika"
    },
    "SS": {
        "name": "Južný Sudán"
    },
    "KH": {
        "name": "Kambodža"
    },
    "CM": {
        "name": "Kamerun"
    },
    "CA": {
        "name": "Kanada"
    },
    "CV": {
        "name": "Kapverdy"
    },
    "QA": {
        "name": "Katar"
    },
    "KZ": {
        "name": "Kazachstan"
    },
    "KE": {
        "name": "Keňa"
    },
    "KG": {
        "name": "Kirgizsko"
    },
    "KI": {
        "name": "Kiribati"
    },
    "CO": {
        "name": "Kolumbia"
    },
    "KM": {
        "name": "Komory"
    },
    "CG": {
        "name": "Kongo"
    },
    "CD": {
        "name": "Konžská demokratická republika"
    },
    "KP": {
        "name": "Kórejská ľudovodemokratická republika"
    },
    "KR": {
        "name": "Kórejská republika"
    },
    "CR": {
        "name": "Kostarika"
    },
    "CU": {
        "name": "Kuba"
    },
    "KW": {
        "name": "Kuvajt"
    },
    "LA": {
        "name": "Laos"
    },
    "LS": {
        "name": "Lesotho"
    },
    "LB": {
        "name": "Libanon"
    },
    "LR": {
        "name": "Libéria"
    },
    "LY": {
        "name": "Líbya"
    },
    "LI": {
        "name": "Lichtenštajnsko"
    },
    "LT": {
        "name": "Litva"
    },
    "LV": {
        "name": "Lotyšsko"
    },
    "LU": {
        "name": "Luxembursko"
    },
    "MK": {
        "name": "Severné Macedónsko"
    },
    "MG": {
        "name": "Madagaskar"
    },
    "HU": {
        "name": "Maďarsko"
    },
    "MY": {
        "name": "Malajzia"
    },
    "MW": {
        "name": "Malawi"
    },
    "MV": {
        "name": "Maldivy"
    },
    "ML": {
        "name": "Mali"
    },
    "MT": {
        "name": "Malta"
    },
    "MA": {
        "name": "Maroko"
    },
    "MH": {
        "name": "Marshallove ostrovy"
    },
    "MU": {
        "name": "Maurícius"
    },
    "MR": {
        "name": "Mauritánia"
    },
    "MX": {
        "name": "Mexiko"
    },
    "FM": {
        "name": "Mikronézia"
    },
    "MM": {
        "name": "Mjanmarsko"
    },
    "MD": {
        "name": "Moldavsko"
    },
    "MC": {
        "name": "Monako"
    },
    "MN": {
        "name": "Mongolsko"
    },
    "MZ": {
        "name": "Mozambik"
    },
    "NA": {
        "name": "Namíbia"
    },
    "NR": {
        "name": "Nauru"
    },
    "DE": {
        "name": "Nemecko"
    },
    "NP": {
        "name": "Nepál"
    },
    "NE": {
        "name": "Niger"
    },
    "NG": {
        "name": "Nigéria"
    },
    "NI": {
        "name": "Nikaragua"
    },
    "NO": {
        "name": "Nórsko"
    },
    "NZ": {
        "name": "Nový Zéland"
    },
    "OM": {
        "name": "Omán"
    },
    "PK": {
        "name": "Pakistan"
    },
    "PW": {
        "name": "Palau"
    },
    "PA": {
        "name": "Panama"
    },
    "PG": {
        "name": "Papua-Nová Guinea"
    },
    "PY": {
        "name": "Paraguaj"
    },
    "PE": {
        "name": "Peru"
    },
    "CI": {
        "name": "Pobrežie Slonoviny"
    },
    "PL": {
        "name": "Poľsko"
    },
    "PT": {
        "name": "Portugalsko"
    },
    "AT": {
        "name": "Rakúsko"
    },
    "GQ": {
        "name": "Rovníková Guinea"
    },
    "RO": {
        "name": "Rumunsko"
    },
    "RU": {
        "name": "Rusko"
    },
    "RW": {
        "name": "Rwanda"
    },
    "SV": {
        "name": "Salvádor"
    },
    "WS": {
        "name": "Samoa"
    },
    "SM": {
        "name": "San Maríno"
    },
    "SA": {
        "name": "Saudská Arábia"
    },
    "SN": {
        "name": "Senegal"
    },
    "SC": {
        "name": "Seychely"
    },
    "SL": {
        "name": "Sierra Leone"
    },
    "SG": {
        "name": "Singapur"
    },
    "SK": {
        "name": "Slovensko"
    },
    "SI": {
        "name": "Slovinsko"
    },
    "SO": {
        "name": "Somálsko"
    },
    "AE": {
        "name": "Spojené arabské emiráty"
    },
    "GB": {
        "name": "Spojené kráľovstvo"
    },
    "US": {
        "name": "Spojené štáty"
    },
    "RS": {
        "name": "Srbsko"
    },
    "LK": {
        "name": "Srí Lanka"
    },
    "CF": {
        "name": "Stredoafrická republika"
    },
    "SD": {
        "name": "Sudán"
    },
    "SR": {
        "name": "Surinam"
    },
    "LC": {
        "name": "Svätá Lucia"
    },
    "KN": {
        "name": "Svätý Krištof a Nevis"
    },
    "ST": {
        "name": "Svätý Tomáš a Princov ostrov"
    },
    "VC": {
        "name": "Svätý Vincent a Grenadíny"
    },
    "SZ": {
        "name": "Svazijsko"
    },
    "SY": {
        "name": "Sýria"
    },
    "SB": {
        "name": "Šalamúnove ostrovy"
    },
    "ES": {
        "name": "Španielsko"
    },
    "CH": {
        "name": "Švajčiarsko"
    },
    "SE": {
        "name": "Švédsko"
    },
    "TJ": {
        "name": "Tadžikistan"
    },
    "IT": {
        "name": "Taliansko"
    },
    "TZ": {
        "name": "Tanzánia"
    },
    "TH": {
        "name": "Thajsko"
    },
    "TG": {
        "name": "Togo"
    },
    "TO": {
        "name": "Tonga"
    },
    "TT": {
        "name": "Trinidad a Tobago"
    },
    "TN": {
        "name": "Tunisko"
    },
    "TR": {
        "name": "Turecko"
    },
    "TM": {
        "name": "Turkménsko"
    },
    "TV": {
        "name": "Tuvalu"
    },
    "UG": {
        "name": "Uganda"
    },
    "UA": {
        "name": "Ukrajina"
    },
    "UY": {
        "name": "Uruguaj"
    },
    "UZ": {
        "name": "Uzbekistan"
    },
    "VU": {
        "name": "Vanuatu"
    },
    "VE": {
        "name": "Venezuela"
    },
    "VN": {
        "name": "Vietnam"
    },
    "TL": {
        "name": "Východný Timor"
    },
    "ZM": {
        "name": "Zambia"
    },
    "ZW": {
        "name": "Zimbabwe"
    }
}